import * as _actions from './actions'
import * as _constants from './constants'
import * as _components from './components'
import * as _containers from './containers'
import _reducer from './reducer'
import * as _selectors from './selectors'

export const actions = _actions
export const constants = _constants
export const components = _components
export const containers = _containers
export const reducer = _reducer
export const selectors = _selectors

export default {
  actions,
  constants,
  components,
  containers,
  reducer,
  selectors,
}
